// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__3IFIw","title":"Panel_title__3ltcS","footer":"Panel_footer__1DjCm"};